export type FrameOrientationSettings = {
  mode: 'horizontal' | 'vertical';
  gap: number;
  /**
   * Number of tracks (rows/columns) on the single axis perpendicular to
   * `mode` — not a number of axes, so the layout stays at most 2D. When set
   * above `1`, the Frame Layout becomes a 2D grid instead of a single
   * row/column.
   */
  crossAxisTrackCount?: number;
};

export const DEFAULT_FRAME_ORIENTATION: FrameOrientationSettings = {
  mode: 'vertical',
  gap: 100,
};

// Currently only the `mode` field of `FrameOrientationSettings` is stored in persistent UI state
type PersistedFrameOrientationSettings = Pick<FrameOrientationSettings, 'mode'>;

/**
 * Map of component IDs to Component Canvas UI settings.
 * These settings are stored in persistent UI state at the user level.
 */
export type ComponentCanvasUISettings = {
  [componentId: string]: {
    frameOrientation: PersistedFrameOrientationSettings;
  };
};
